<dc-layout-header *ngIf="!data.hideNavigation"></dc-layout-header>
<router-outlet></router-outlet>
<dc-toaster-container></dc-toaster-container>
<!-- <toaster name="main" class="bottom"></toaster>
<error-occurred-modal id="errorOccured" class="basic small"></error-occurred-modal> -->
